export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8483.ac6486d5.jpg";